export default {
  // 通用
  'pages.common.more': '更多',

  // 声纹说话人 Speakers
  'pages.console.speakers.column.speaker': '说话人',
  'pages.console.speakers.column.samples': '样本',
  'pages.console.speakers.error.sampleTooShort': '样本过短，需至少2秒',
  'pages.console.speakers.error.recordFirst': '请先录音或录音无效',
  'pages.console.speakers.error.selectConversation': '请选择对话音频',
  'pages.console.speakers.msg.convUploadSuccess': '对话音频上传成功',
  'pages.console.speakers.msg.convUploadFailed': '对话音频上传失败',
  'pages.console.speakers.msg.saveSuccess': '保存成功',
  'pages.console.speakers.msg.saveFailed': '保存失败',
  'pages.console.speakers.modal.edit': '编辑',
  'pages.console.speakers.uploadFile': '上传文件',
  'pages.console.speakers.conversation': '对话音频',
  'pages.console.speakers.stopRecording': '点击停止录音',
  'pages.console.speakers.startRecording': '点击开始录音',

  // 记忆观察池 MemoryObservationCandidates
  'pages.memoryObservation.status.pending': '待观察',
  'pages.memoryObservation.status.promoted': '已晋升',
  'pages.memoryObservation.status.rejected': '已拒绝',
  'pages.memoryObservation.status.decayed': '已衰减',
  'pages.memoryObservation.slot.age': '年龄',
  'pages.memoryObservation.slot.communicationStyle': '沟通风格',
  'pages.memoryObservation.slot.dislikes': '规避',
  'pages.memoryObservation.slot.family': '家庭',
  'pages.memoryObservation.slot.relationships': '关系',
  'pages.memoryObservation.slot.extra': '其他',
  'pages.memoryObservation.msg.loadFailed': '加载观察池失败',
  'pages.memoryObservation.msg.promoteSuccess': '已合并到长期画像',
  'pages.memoryObservation.msg.promoteFailed': '晋升失败',
  'pages.memoryObservation.msg.rejectSuccess': '已标记为拒绝',
  'pages.memoryObservation.msg.rejectFailed': '操作失败',
  'pages.memoryObservation.loading': '加载观察池…',
  'pages.memoryObservation.disabled.title': '观察池未开启',
  'pages.memoryObservation.disabled.desc':
    '在管理后台「系统配置 → 应用程序」中开启「长期记忆观察池」后，跨会话采集的候选事实会在此列出，达到命中阈值可自动晋升，也可手动确认或拒绝。',
  'pages.memoryObservation.hint.autoPromotePrefix': '自动晋升需跨 ',
  'pages.memoryObservation.hint.autoPromoteMid': ' 个不同会话命中同一槽位；memoryCollectionDays（兼容配置）：',
  'pages.memoryObservation.column.slot': '槽位',
  'pages.memoryObservation.column.content': '内容',
  'pages.memoryObservation.column.convCount': '会话数',
  'pages.memoryObservation.tag.promotable': '可晋升',
  'pages.memoryObservation.column.confidence': '置信',
  'pages.memoryObservation.column.source': '来源',
  'pages.memoryObservation.tag.fastLane': '快车道',
  'pages.memoryObservation.tag.collected': '采集',
  'pages.memoryObservation.column.device': '设备',
  'pages.memoryObservation.column.convId': '会话ID',
  'pages.memoryObservation.column.createdAt': '创建时间',
  'pages.memoryObservation.column.lastSeen': '最后命中',
  'pages.memoryObservation.tooltip.lastSeen': '候选在对话中最近一次被强化/命中的时间',
  'pages.memoryObservation.column.status': '状态',
  'pages.memoryObservation.column.action': '操作',
  'pages.memoryObservation.button.promote': '确认写入',
  'pages.memoryObservation.button.reject': '拒绝',

  // 向量长期记忆锚点 LongTermMemoryAnchors
  'pages.memoryAnchors.msg.getStatusFailed': '获取长期记忆状态失败',
  'pages.memoryAnchors.msg.getChunksFailed': '获取长期记忆锚点失败',
  'pages.memoryAnchors.msg.searchFailed': '检索长期记忆失败',
  'pages.memoryAnchors.msg.contentRequired': '记忆内容不能为空',
  'pages.memoryAnchors.msg.updateSuccess': '记忆锚点已更新',
  'pages.memoryAnchors.msg.updateFailed': '更新记忆锚点失败',
  'pages.memoryAnchors.msg.deleteSuccess': '记忆锚点已删除',
  'pages.memoryAnchors.msg.deleteFailed': '删除记忆锚点失败',
  'pages.memoryAnchors.clear.confirmTitle': '确认清空全部向量长期记忆？',
  'pages.memoryAnchors.clear.confirmContent':
    '该操作会删除当前智能体记忆库中的所有摘要锚点，关闭长期记忆不会触发此操作。删除后不可恢复。',
  'pages.memoryAnchors.clear.confirmOk': '确认清空',
  'pages.memoryAnchors.clear.success': '已清空 {count} 条记忆锚点',
  'pages.memoryAnchors.clear.refreshFailed': '清空已成功，但刷新列表失败，请点击「刷新锚点」重试',
  'pages.memoryAnchors.clear.failed': '清空长期记忆失败',
  'pages.memoryAnchors.needSave': '保存智能体后才可以管理长期记忆锚点。',
  'pages.memoryAnchors.column.content': '内容',
  'pages.memoryAnchors.column.action': '操作',
  'pages.memoryAnchors.button.save': '保存',
  'pages.memoryAnchors.button.edit': '编辑',
  'pages.memoryAnchors.button.delete': '删除',
  'pages.memoryAnchors.button.refresh': '刷新锚点',
  'pages.memoryAnchors.button.clearAll': '清空全部向量记忆',
  'pages.memoryAnchors.delete.confirmTitle': '确认删除这条记忆锚点？',
  'pages.memoryAnchors.delete.confirmOk': '删除',
  'pages.memoryAnchors.alert.title': '向量长期记忆库',
  'pages.memoryAnchors.alert.desc': '这里管理的是对话结束后自动写入向量库的摘要锚点；上方 JSON 是结构化画像记忆，二者互相独立。',
  'pages.memoryAnchors.tag.enabled': '已开启',
  'pages.memoryAnchors.tag.disabled': '未开启',
  'pages.memoryAnchors.tag.notCreated': '未创建',
  'pages.memoryAnchors.tag.systemOff': '系统开关关闭',
  'pages.memoryAnchors.search.placeholder': '输入问题或关键词，预览长期记忆检索结果',
  'pages.memoryAnchors.searchPreview': '检索预览',
  'pages.memoryAnchors.search.similarity': '相似度 {score}',

  // AgentMemorySetting 观察池/向量锚点
  'pages.agentMemorySetting.observationPool.label': '观察池候选',
  'pages.agentMemorySetting.observationPool.tooltip':
    '需在系统管理端开启「长期记忆观察池」。达到跨会话命中数可自动写入画像，也可在此手动确认或拒绝。',
  'pages.agentMemorySetting.vectorAnchor.label': '向量锚点',

  // AgentSetting 长期记忆画像 placeholder 补充
  'pages.agentSetting.memory.longTerm.placeholder.birthday': '例如：3月15日、1990-05-20',
  'pages.agentSetting.memory.longTerm.placeholder.mbti': '例如：INTJ',
  'pages.agentSetting.memory.longTerm.placeholder.timezone': '例如：UTC+8',
  'pages.agentSetting.memory.longTerm.placeholder.communication_style': '例如：简短、幽默',

  // AgentSetting 提供商商业授权
  'pages.agentSetting.provider.commercialLicenseRequired': '{name}（需商业授权）',

  // Agents 商业标签
  'pages.agents.tag.commercial': '商业',

  // Settings OpenID
  'pages.settings.openid.label': 'OpenID：',

  // Devices 物联卡状态枚举释义 + 复制提示
  'pages.devices.simState.hintWrap': '{raw}（{hint}）',
  'pages.devices.simState.sp.1': '移动',
  'pages.devices.simState.sp.2': '联通',
  'pages.devices.simState.sp.3': '电信',
  'pages.devices.simState.cardForm.1': '插拔',
  'pages.devices.simState.cardForm.2': '陶瓷',
  'pages.devices.simState.cardForm.3': '贴片',
  'pages.devices.simState.cardForm.4': 'MP2',
  'pages.devices.simState.cardCl.1': '测试期',
  'pages.devices.simState.cardCl.2': '沉默期',
  'pages.devices.simState.cardCl.3': '正式期',
  'pages.devices.simState.cState.1': '停机',
  'pages.devices.simState.cState.2': '正常',
  'pages.devices.simState.cState.3': '待激活',
  'pages.devices.simState.cState.4': '预销户',
  'pages.devices.simState.cState.5': '销户',
  'pages.devices.simState.cState.6': '休眠',
  'pages.devices.simState.cState.7': '申请销户',
  'pages.devices.simState.gprsState.1': '正常',
  'pages.devices.simState.gprsState.2': '关停，次月恢复',
  'pages.devices.simState.gprsState.3': '关停，次月不恢复',
  'pages.devices.simState.gprsState.4': '主动关停，系统不恢复',
  'pages.devices.copy.macTooltip': '复制完整 MAC',
  'pages.devices.copy.macCopiedTooltip': 'MAC 已复制',
  'pages.devices.copy.iccidTooltip': '复制 ICCID',
  'pages.devices.copy.iccidCopiedTooltip': 'ICCID 已复制',
  'pages.devices.device.callNumber': '设备号',
  'pages.devices.copy.callNumberTooltip': '复制设备号',
  'pages.devices.copy.callNumberCopiedTooltip': '设备号已复制',
};
